import React from 'react';
import PropTypes from 'prop-types';
import SMReservationHelper from 'components/helpers/SMReservationHelper';
import SMReservationStatusView from '../../shared/SMReservationStatusView';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMRenderHelper from 'components/helpers/SMRenderHelper';
import sprintf from 'sprintf';
import SMConst from 'lib/SMConst';

class SMUReservationListTableRow extends React.Component {

  didSelect(e){
    if(this.props.delegate && typeof this.props.delegate.tableDidSelectRowAtIndex === 'function'){
      this.props.delegate.tableDidSelectRowAtIndex(this.props.rowIndex, e);
    }
  }

  render() {
    let reservation = this.props.reservation,
        className = "dashboard-sidecol__scrollarea-list",
        style = {},
        corpName = reservation.user.corp_name || "",
        priceText = reservation.billing ? sprintf(("%s(" + I18n.t("dashboard.label_000706") + ")"), reservation.billing.total_pay_amount_for_user_with_tax_text) : "",
        ownerImageUrl = reservation.owner ? SMFormatHelper.ownerImageUrl(reservation.owner, reservation.owner.profile_image) : SMFormatHelper.defaultIcon();

    if (this.props.isCurrent) className += ' is-current';

    let badge = null;
    if (!reservation.is_read_message) {
      className += ' is-unread';
      badge = <i className="fa fa-circle reserve-list__badge" />;
    }
    let directIcon = "";
    if (reservation.is_direct) {
      directIcon = <i className="fa fa-bolt mr5 icon-direct"></i>;
    }
    return (
      <li className={className}>
        <a href={Routes.dashboard_reservation_path(reservation.uid)}
          onClick={this.didSelect.bind(this)}
          target={this.props.target}
          className="js-push-state dashboard-sidecol__scrollarea-list-link">
          <p className="reserve-list__id">{badge}{I18n.t("dashboard.label_000093")}：{reservation.id}</p>
          <SMReservationStatusView reservation={reservation} className="reserve-list__status reserve-status-icon" />
          <p className="reserve-list__date">{SMRenderHelper.renderReservationIcon(reservation)}{reservation.reserved_date_text}</p>
          <img src={ownerImageUrl} className="reserve-list__img" alt={reservation.owner ? SMFormatHelper.ownerName(reservation.owner) : "ホスト未定"} />
          <p className="reserve-list__name">{directIcon}{reservation.owner ? SMFormatHelper.ownerName(reservation.owner) : "ホスト未定"}</p>
          <p className="reserve-list__company">&nbsp;</p>
          <p className="reserve-list__space">{reservation.room ? SMFormatHelper.roomName(reservation.room) : "スペース未定"}</p>
          <p className="reserve-list__price">{priceText}</p>
        </a>
      </li>
    );
  }
}
SMUReservationListTableRow.propTypes = {
  delegate: PropTypes.object,
  rowIndex: PropTypes.number.isRequired,
  isCurrent: PropTypes.bool,
  target: PropTypes.string,
  reservation: PropTypes.object.isRequired
};
SMUReservationListTableRow.defaultProps = {
  rowIndex: 0,
  target: "_self",
  isCurrent: false,
};
export default SMUReservationListTableRow;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/users/reservations/SMUReservationListTableRow.jsx